"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);

const DATE = _moment2.default.HTML5_FMT.DATE

// The days a report covers: the last `days` days up to now (1 is today), or
// the dates an admin picked, YYYY-MM-DD in the browser's zone.


// The range asked for before the first summary brings the server's Limits.
 const INITIAL_RANGE_DAYS = 30; exports.INITIAL_RANGE_DAYS = INITIAL_RANGE_DAYS

// The choice as RFC3339 instants: the start of its first day to the end of
// its last day, or now if that's sooner.
 const toInterval = (choice) => {
  const now = _moment2.default.call(void 0, )
  const [first, last] = 'days' in choice
    ? [now.clone().subtract(choice.days - 1, 'days'), now]
    : [_moment2.default.call(void 0, choice.start, DATE), _moment2.default.min(now, _moment2.default.call(void 0, choice.end, DATE).endOf('day'))]
  return { Start: first.startOf('day').toISOString(), End: last.toISOString() }
}; exports.toInterval = toInterval

// The calendar days from start to end, both included.
 const countDays = (start, end) =>
  _moment2.default.call(void 0, end, DATE).diff(_moment2.default.call(void 0, start, DATE), 'days') + 1; exports.countDays = countDays

 const firstDayOf = (choice) => 'days' in choice
  ? _moment2.default.call(void 0, ).subtract(choice.days - 1, 'days').format(DATE)
  : choice.start; exports.firstDayOf = firstDayOf

 const lastDayOf = (choice) => 'days' in choice
  ? _moment2.default.call(void 0, ).format(DATE)
  : choice.end; exports.lastDayOf = lastDayOf
